import { loginStart, loginClearValidationErrors, changeRetailerId } from '../store/login/login.actions';
import { UsernameLogin } from '../components/username-login';
import { getIamLoginUrl, shouldUseIamFlowForCurrentHost } from '../utils/iam-login-url';
const {
  useCallback,
  useEffect
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  useHistory
} = ReactRouterDOM;
export const UsernameLoginContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isIamLoginEnabled = shouldUseIamFlowForCurrentHost(svs.core.detect.feature('ft-iam-login'));
  const iamUsernameLoginUrl = getIamLoginUrl('/logga-in/dev-user-login');
  const {
    isLoading,
    isComplete,
    retailerId,
    rememberRetailerId: storeRememberRetailerId,
    validationErrors,
    iamUserNotifications,
    iamParams
  } = useSelector(({
    login
  }) => login);
  const hasIamRedirectContext = Boolean(iamParams?.redirectUri && iamParams?.state);
  useEffect(() => {
    if (!isIamLoginEnabled) {
      return;
    }
    if (!hasIamRedirectContext) {
      window.location.assign(iamUsernameLoginUrl);
      return;
    }
    if (window.location.search !== '?iam=1') {
      history.replace({
        pathname: history.location.pathname,
        search: 'iam=1'
      });
    }
  }, [history, hasIamRedirectContext, iamUsernameLoginUrl, isIamLoginEnabled]);
  const hasToChangePassword = useSelector(({
    login
  }) => login.isComplete && login.mustChangePassword);
  const hasValidationErrors = Boolean(validationErrors);
  const handleClearValidationError = useCallback(() => {
    if (hasValidationErrors) {
      dispatch(loginClearValidationErrors());
    }
  }, [dispatch, hasValidationErrors]);
  const handleChangeRetailerId = retailerId => {
    dispatch(changeRetailerId(retailerId));
  };
  const onSubmit = args => {
    dispatch(loginStart(args));
  };
  return <UsernameLogin hasToChangePassword={hasToChangePassword} iamUserNotifications={iamUserNotifications} isComplete={isComplete} isLoading={isLoading} isRememberRetailerIdChecked={storeRememberRetailerId} onChangeRetailerId={handleChangeRetailerId} onClearValidationError={handleClearValidationError} onSubmit={onSubmit} retailerId={retailerId} />;
};